import { render, staticRenderFns } from "./Detail.vue?vue&type=template&id=27691ec1&scoped=true"
import script from "./Detail.vue?vue&type=script&lang=js"
export * from "./Detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27691ec1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('27691ec1')) {
      api.createRecord('27691ec1', component.options)
    } else {
      api.reload('27691ec1', component.options)
    }
    module.hot.accept("./Detail.vue?vue&type=template&id=27691ec1&scoped=true", function () {
      api.rerender('27691ec1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/sfe/taskAssignment/components/ImportExcel/Detail.vue"
export default component.exports